import Modal from 'bootstrap/js/src/modal'

// « Prendre rendez-vous » : ouvre le formulaire dans une modale, sans quitter la page.
// Cibles : liens vers #rendez-vous, liens .js-appointment-modal, et tout lien « rendez-vous » vers la page contact
// (boutons saisis dans les contenus du BO).
//
// Destinataire : un lien « ?destinataire=baye#rendez-vous » (boutons « Écrire » de la page cabinet) ouvre la
// même modale avec le champ « destinataire » du formulaire présélectionné (option dont le libellé contient
// « baye ») et le titre « Écrire à Me Sarah BAYE ». Les adresses e-mail ne sont jamais dans la page : CF7 les
// associe aux libellés (pipes « Me Sarah BAYE|s.baye@… »).
const APPOINTMENT_HASH = '#rendez-vous'
const RECIPIENT_PARAM = 'destinataire'

function getModal() {
  const modalEl = document.getElementById('modal-rendez-vous')

  return modalEl ? Modal.getOrCreateInstance(modalEl) : null
}

function setRecipient(modalEl, recipient) {
  const select = modalEl.querySelector(`select[name="${RECIPIENT_PARAM}"]`)
  const title = modalEl.querySelector('.modal-title')
  if (title && !title.dataset.defaultTitle) {
    title.dataset.defaultTitle = title.textContent
  }

  let option = null
  if (select) {
    const needle = (recipient || '').trim().toLowerCase()
    option = needle ? [...select.options].find((opt) => opt.text.toLowerCase().includes(needle)) : null
    select.value = option ? option.value : select.options[0]?.value
  }

  if (title) {
    // « Le cabinet » → « Écrire au cabinet », sinon « Écrire à Me … »
    const recipientLabel = option && /^le /i.test(option.text) ? option.text.replace(/^le /i, 'au ') : `à ${option?.text}`
    title.textContent = option ? `Écrire ${recipientLabel}` : title.dataset.defaultTitle
  }
}

function openModal(recipient = null) {
  const modalEl = document.getElementById('modal-rendez-vous')
  if (!modalEl) {
    return
  }

  setRecipient(modalEl, recipient)
  getModal().show()
}

document.addEventListener('click', (e) => {
  const link = e.target.closest('a[href]')
  const modalEl = document.getElementById('modal-rendez-vous')
  if (!modalEl || !link || e.defaultPrevented) {
    return
  }

  const linkUrl = new URL(link.href, window.location.href)
  const isAppointmentLink = linkUrl.hash === APPOINTMENT_HASH ||
    link.classList.contains('js-appointment-modal') ||
    linkUrl.pathname === modalEl.dataset.contactPath && /rendez-vous/i.test(link.textContent)

  if (!isAppointmentLink) {
    return
  }

  e.preventDefault()
  openModal(linkUrl.searchParams.get(RECIPIENT_PARAM))
})

// lien direct vers …#rendez-vous (éventuellement avec ?destinataire=) : ouverture au chargement
if (window.location.hash === APPOINTMENT_HASH) {
  window.addEventListener('load', () => openModal(new URL(window.location.href).searchParams.get(RECIPIENT_PARAM)))
}
